import React, { SVGProps } from 'react';

export const IconMinus = (props: SVGProps<SVGSVGElement>) => <svg fill="none" viewBox="0 0 32 32" width="1em" height="1em" {...props}><path fill="currentColor" d="M2 14.47v3.06c0 .26.21.47.47.47h27.06c.26 0 .47-.21.47-.47v-3.06a.47.47 0 0 0-.47-.47H2.47a.47.47 0 0 0-.47.47Z"/></svg>;
